/**
 * Функция для получения доп контента кнопки депозита (при выбранном бонусе)
 * @param selectedBonus выбранный бонус (Bonus | undefind)
 * @param amount сумма депозита (string | undefined)
 * @param currencyIcon знак валюты (string)
 * @param currencyName трехбуквенный код валюты
 * @returns **additionalButtonContent** отформатированная строка с контентом из выбранного бонуса для подстановки в кнопку депозита
 */

import { Bonus } from 'react-easyrocket';

export type ButtonContentParams = {
  selectedBonus: Bonus | null;
  amount?: string;
  currencyIcon: string;
  currencyName: string;
  hasError: boolean;
};

export const additionalButtonContent = ({
  selectedBonus,
  amount,
  currencyIcon,
  currencyName,
  hasError
}: ButtonContentParams): string | undefined => {
  if (!selectedBonus || !amount || hasError) {
    return undefined;
  } else {
    const bonusAmount = selectedBonus.percent
      ? Math.min(
          (Number(amount) * selectedBonus.percent) / 100,
          selectedBonus.maxPayout[currencyName] / 100 || Infinity
        ).toFixed(2)
      : 0;
    const depositAndBonusSum = (Number(bonusAmount) + Number(amount)).toFixed(2);
    const freeSpinsString = selectedBonus.freeSpins ? ` + ${selectedBonus.freeSpins} FS` : '';

    return `${currencyIcon}${depositAndBonusSum}${freeSpinsString}`;
  }
};
